import React, { useMemo } from 'react';
import { toast } from 'react-toastify';
import * as classes from './Notification.module.scss';
import { ErrorLinkProps, ErrorNotification, InfoNotification, SuccessNotification } from './Notification';

export interface NotificationOptionsProps {
  link?: string;
  linkText?: string;
  caption?: string;
}

const options = {
  className: classes.toastContainer,
};
const info = (message: string) => toast(<InfoNotification message={message} />, options);

const errorOptions = {
  ...options,
  className: classes.toastContainerError,
};
const error = (message: string, caption?: string, link?: ErrorLinkProps) =>
  toast(<ErrorNotification message={message} caption={caption} link={link} />, errorOptions);

const successOptions = {
  ...options,
  className: classes.toastContainerSuccess,
};
const success = (message: string) => toast(<SuccessNotification message={message} />, successOptions);

export const useNotification = () => {
  return useMemo(
    () => ({
      info,
      success,
      error,
    }),
    [],
  );
};
